var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.windowClass},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('report-per-agent',{attrs:{"show":true,"area":_vm.SELECTED_AREA}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }